import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";

import { routes } from "@app/routing";
import HomeSvg from "@assets/svg/icons/home.svg";
import BillingSvg from "@assets/svg/icons/billing.svg";
import AccountSvg from "@assets/svg/icons/account.svg";
import NavItem from "@app/components/navigation/navItem";
import { HeapEventLocation, HEAP_EVENTS } from "@app/provider/types";
import { UserContext } from "@app/provider";
import { useBillingAccess } from "@app/postBill/postBillWrapper";
import "./mobileNavigation.scss";

const messages = defineMessages({
  mobileNavigationHome: {
    id: "mobileNavigationHome",
    defaultMessage: "Home",
  },
  mobileNavigationBillingCenter: {
    id: "mobileNavigationBillingCenter",
    defaultMessage: "Billing Center",
  },
  mobileNavigationMyAccount: {
    id: "mobileNavigationMyAccount",
    defaultMessage: "My Account",
  },
});

const MobileNavigation: FC = () => {
  const intl = useIntl();
  const { uppUser } = React.useContext(UserContext);
  const { hasAccess, isLoading, hasError } = useBillingAccess();

  return (
    <nav className="mobile-navigation">
      <ul className="mobile-navigation__content">
        <NavItem
          icon={HomeSvg}
          title={intl.formatMessage(messages.mobileNavigationHome)}
          to={routes.home}
          heapEventName={HEAP_EVENTS.upp_click_home}
        >
          {intl.formatMessage(messages.mobileNavigationHome)}
        </NavItem>

        {hasAccess && !isLoading && !hasError && (
          <NavItem
            icon={BillingSvg}
            title={intl.formatMessage(messages.mobileNavigationBillingCenter)}
            to={routes.billingCenter}
            heapEventName={HEAP_EVENTS.upp_click_billingcenter}
            heapEventProps={{
              location: HeapEventLocation.horizontalMenu,
              identity: uppUser?.patientUID,
            }}
          >
            {intl.formatMessage(messages.mobileNavigationBillingCenter)}
          </NavItem>
        )}

        <NavItem
          icon={AccountSvg}
          title={intl.formatMessage(messages.mobileNavigationMyAccount)}
          to={routes.profile}
          heapEventName={HEAP_EVENTS.upp_click_patientprofile}
          heapEventProps={{ location: HeapEventLocation.horizontalMenu }}
        >
          {intl.formatMessage(messages.mobileNavigationMyAccount)}
        </NavItem>
      </ul>
    </nav>
  );
};

export default MobileNavigation;
